import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'glamor';
import rightArrow from '../images/right_arrow.svg';
import VstSubmenuItem from './VstSubmenuItem';
import VstComponent from './VstComponent';

const KEYCODES = {
  ENTER: 13,
};
class VstListItem extends VstComponent {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };

    this.onClick = this.onClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  render() {
    return {
      text: this.text.bind(this),
      header: this.header.bind(this),
      subheader: this.subheader.bind(this),
      divider: this.divider.bind(this),
      element: this.element.bind(this),
      select: this.select.bind(this),
    }[this.props.role]();
  }

  onClick(e) {
    const { closeMenu, closeOnClick, onClick } = this.props;
    if (onClick) {
      onClick(e);
    }
    if (closeMenu && closeOnClick) {
      closeMenu();
    }
  }

  _getCSS() {
    const rule = {
      '&:hover, &:active, &:focus': {
        outline: 'none',
        backgroundColor: this._theme(1),
      }
    };
    if (this.props.selected) {
      rule.color = this._theme(8);
    }
    return css(rule);
  }

  onKeyDown(e) {
    if (e.keyCode === KEYCODES.ENTER) {
      this.onClick(e);
    }
  }

  text() {
    const { className, children, style, selected } = this.props;

    return (
      <li
        className={`vst-list-item text ${className} ${selected ? 'selected' : ''}`}
        onKeyDown={this.onKeyDown}
        {...this._getCSS()}
      >
        <button
          className="vst-no-button libutton"
          style={style}
          aria-pressed={selected}
          onClick={this.onClick}
          {...this._getCSS()}
        >
          {children}
        </button>
      </li>
    );
  }

  header() {
    const { className, children, style } = this.props;
    return (
      <li
        className={`vst-list-item header ${className}`}
        style={style}
        tabIndex={-1}
      >
        <h3>{children}</h3>
      </li>
    );
  }

  subheader() {
    const { className, children, style } = this.props;
    return (
      <li
        className={`vst-list-item subheader ${className}`}
        style={style}
        tabIndex={-1}
      >
        <h3>{children}</h3>
      </li>
    );
  }

  divider() {
    return (
      <li
        className={'vst-list-item subheader'}
        tabIndex={this.props.tabIndex}
        tabIndex={-1}
        style={{ padding: 0 }}
      />
    );
  }

  element() {
    const { className, children, style, selected } = this.props;

    return (
      <li
        className={`vst-list-item element ${className} ${selected ? 'selected' : ''}`}
        style={style}
        aria-pressed={selected}
        {...this._getCSS()}
      >
        {children}
      </li>
    );
  }

  select() {
    const { className, children, style, text, selected, isList, ...restProps } = this.props;
    const openSubmenu = () => {
      this.setState({ visible: true });
    };
    const closeSubmenu = () => {
      this.setState({ visible: false });
    };

    return (
      <li
        className={`vst-list-item select ${className} ${selected ? 'selected' : ''}`}
        {...restProps}
        {...this._getCSS()}
      >
        <button
          className="vst-no-button libutton"
          style={style}
          onClick={openSubmenu}
          onMouseEnter={openSubmenu}
          onMouseLeave={closeSubmenu}
          onBlur={closeSubmenu}
          onFocus={openSubmenu}
          aria-expanded={this.state.visible}
          {...this._getCSS()}
        >
          {text}

          <VstSubmenuItem
            ref={submenu => {this.submenu = submenu;}}
            closeMenu={this.props.closeMenu}
            visible={this.state.visible}
            isMobile={this.props.isMobile}
            isList={isList}
            onBackButtonClick={() => this.setState({ visible: false })}
            headerTitle={this.props.headerTitle}
            headerClassName={this.props.headerClassName}
            headerApplyButton={this.props.headerApplyButton}
            headerBackButton={this.props.headerBackButton}
          >
            {children}
          </VstSubmenuItem>
          {rightArrow()}
        </button>

        <VstSubmenuItem
          ref={submenu => {this.submenu = submenu;}}
          closeMenu={this.props.closeMenu}
          visible={this.state.visible}
          isMobile={this.props.isMobile}
          closeSubmenu={closeSubmenu}
          onBackButtonClick={closeSubmenu}
          openSubmenu={openSubmenu}
          isList={isList}
        >
          {children}
        </VstSubmenuItem>
      </li>
    );
  }
}

VstListItem.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  closeMenu: PropTypes.func,
  closeOnClick: PropTypes.bool,
  onClick: PropTypes.func,
  tabIndex: PropTypes.number,
  text: PropTypes.string,
  hidden: PropTypes.bool,
  isMobile: PropTypes.bool,
  maxHeight: PropTypes.string,
  selected: PropTypes.bool,
  role: PropTypes.oneOf([
    'text',
    'header',
    'subheader',
    'divider',
    'element',
    'select',
  ]),
};

VstListItem.defaultProps = {
  role: 'text',
  className: '',
  style: {},
  hidden: false,
  maxHeight: undefined,
  closeOnClick: true
};

export default VstListItem;
